<template>
    <form class="modify modify-company warn-on-exit" method="post">
        <!-- Basic Information -->
        <fieldset>
            <h3 class="form-heading">Company Information</h3>
            <div class="form-body">
                <txt label="company" v-model="model.name"></txt>
                <div class="split-fields">
                    <txt label="id_number" v-model="model.id_number"></txt>
                    <txt label="website" v-model="model.website"></txt>
                </div>
                <div class="split-fields">
                    <txt label="phone" v-model="model.phone"></txt>
                    <txt label="email" v-model="model.email"></txt>
                </div>
                 <txt label="rhipe_tenant_id" v-model="model.rhipe_tenant_id"></txt>
                <!--<contact-list name="Company" v-model="model.contact"></contact-list>-->
            </div><!-- .form-body -->
        </fieldset>
        <address-form name="Company" v-model="model.address"></address-form>
        <div class="buttons">
            <button class="btn btn-danger btn-sml"><i class="icon icon-cancel"></i> Reset</button>
            <button @click.prevent="store" class="btn btn-success btn-sml"><i class="icon icon-save"></i> Save</button>
        </div>
    </form>

</template>

<script>
    export default {
        props: {
            name: { default: '' },
        },
        components: {
            'address-form': require('../address-form.vue').default,
            // 'contact-list': require('../../components/contact-list.vue').default
        },
        data() {
            return {
                model: {
                    address: {},
                    name: '',
                    public_id: 0,
                    company: {},
                    id_number: '',
                    website: '',
                    phone: '',
                    email: '',
                    rhipe_tenant_id: '',
                    contact: { id: 0, name: '' }
                }
            }
        },
        created() {
            this.$eventHub.$on('companySubmit', this.store);
            this.$eventHub.$on('setCompany', this.setCompany);
        },
        methods: {
            store() {
                let before = this.model;
                this.model = Object.assign({}, this.model, this.model.address);
                this.$store('/api/company/store', this);
                this.model = before;
                this.$eventHub.$emit('updatePageTitle', this.model.name);
                this.$parent.model.heading = this.model.name;
            },
            setCompany(data) {
                this.model = this.$setData(data, this.model);
                this.model.rhipe_tenant_id = data.meta.rhipe_tenant_id;
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('companySubmit', this.store);
            this.$eventHub.$off('setCompany', this.setCompany);
        }
    }
</script>
